import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import { Link, useParams } from 'react-router-dom'
import {
  fetchTreeAdGroups,
  fetchTreeCampaigns,
} from 'features/dashboard/tree/dashboardTreeSlice'
import StatusAndSort from 'features/dashboard/tree/StatusAndSort'
import useWindowDimensions from 'utils/hooks/useWindowDimensions'
import Loading from 'components/loading/Loading'
import { CampaignTypes } from '../../Codes'
import CampaignList from './CampaignList'

const Tree = () => {
  const dispatch = useDispatch()
  const { accountId: adAccountId } = useParams()
  const {
    tree: { visible, campaigns, isLoading, status, sort, selectedCampaignId },
    info: { visible: infoVisible },
  } = useSelector(state => state.dashboard)
  const { height: windowHeight } = useWindowDimensions()
  const treeHeight = useMemo(
    () => (infoVisible ? 1375 : windowHeight - 269),
    [infoVisible, windowHeight]
  )

  useEffect(() => {
    if (adAccountId && visible) {
      dispatch(fetchTreeCampaigns())
    }
  }, [dispatch, status, sort, adAccountId, visible])

  useEffect(() => {
    if (selectedCampaignId) {
      dispatch(fetchTreeAdGroups(selectedCampaignId))
    }
  }, [dispatch, selectedCampaignId])

  return (
    <div className={classNames('dashboard_list', { on: visible })}>
      <div className="tit_dashbaord">
        <Link
          to={`/${adAccountId}/dashboard`}
          className="link_tit"
          onClick={() => {
            if (adAccountId) {
              // TODO: 컴포넌트별 초기화 메서드 있는지 확인 필요
              // dispatch(refreshDashboard());
              window.location.replace(`/${adAccountId}/dashboard`)
            }
          }}>
          캠페인 ({campaigns.length})
        </Link>
        <StatusAndSort />
      </div>
      {isLoading ? (
        <div style={{ height: Math.min(windowHeight, treeHeight) }}>
          <Loading />
        </div>
      ) : (
        <ul className="list_dashbaord" style={{ height: treeHeight }}>
          <CampaignList campaignType={CampaignTypes.PREMIUM_LINK} />
          <CampaignList campaignType={CampaignTypes.TALK_CHANNEL} />
        </ul>
      )}
    </div>
  )
}
export default Tree
